import Connection from '../../Connection';
import { WebsocketCommandResponse } from '../MainWebsocketCommands';
import { WebsocketCommand } from '../useManagedWebsocket';

export class WebsocketPcbResetCommand extends WebsocketCommand {
    public async execute(connection: Connection): Promise<WebsocketCommandResponse> {
        connection.resetPcb();
        return { success: true };
    }
}
